export function isLocalHostname(hostname: string): boolean {
  const host = hostname.toLowerCase();
  if (host === "localhost" || host === "127.0.0.1" || host === "::1" || host === "[::1]") {
    return true;
  }

  if (host.endsWith(".local") || !host.includes(".")) {
    return true;
  }

  const parts = host.split(".").map((part) => Number(part));
  if (parts.length !== 4 || parts.some((part) => Number.isNaN(part))) {
    return false;
  }

  const [first, second] = parts;
  return first === 10 || (first === 172 && second >= 16 && second <= 31) || (first === 192 && second === 168);
}

export function getLocalBaseUrl(baseUrl?: string): string {
  const rawBaseUrl = (baseUrl || "").trim();
  if (!rawBaseUrl || rawBaseUrl.startsWith("/") || rawBaseUrl.startsWith("./") || rawBaseUrl.startsWith("../")) {
    return rawBaseUrl;
  }

  try {
    const url = new URL(rawBaseUrl, window.location.origin);
    if (url.origin === window.location.origin || isLocalHostname(url.hostname)) {
      return rawBaseUrl;
    }
  } catch {
    return "";
  }

  return "";
}

export function getLocalUrl(value?: string): string {
  const rawValue = (value || "").trim();
  if (!rawValue) {
    return "";
  }

  if (rawValue.startsWith("/") || rawValue.startsWith("./") || rawValue.startsWith("../") || rawValue.startsWith("#")) {
    return rawValue;
  }

  try {
    const url = new URL(rawValue, window.location.origin);
    if (url.origin === window.location.origin || isLocalHostname(url.hostname)) {
      return url.toString();
    }
  } catch {
    return "";
  }

  return "";
}
